<div class="login-home background-body">
    <div class="container auth-logo-card-spacing align-items-center d-flex">
      <!-- Logo Section -->
      <div class="logo-section">
        <img :src="styleConfig.login_page_logo" alt="aicone Logo" class="logo" />
      </div>

      <!-- OTP Form Section -->
      <div class="sign-in-form">
        <div class="mb-4 text-start">
          <h2 class="text-black fw-bold">Enter OTP</h2>
          <p class="text-muted small mb-4 mt-2">
            We sent a code to your email. Enter it below to verify.
          </p>
        </div>

        <form @submit.prevent="submit_otp">
          <div class="form-floating-custom">
            <input
              type="text"
              maxlength="6"
              class="form-input"
              v-model="otp"
            />
            <label for="otp" class="form-label">One-Time Password</label>
          </div>

          <button type="submit" class="btn sign-up-btn btn-dark w-100 fw-bold mb-2" :disabled="loading">
            <span v-if="loading">Verifying...</span>
            <span v-else>Verify OTP</span>
          </button>

          <div class="text-center mt-3 small">
            <span class="text-muted">Didn't receive the code?</span>
            <button
                type="button"
                class="btn btn-link p-0 ms-1"
                @click="resend_otp"
                :disabled="resending"
            >
                <span v-if="resending">Resending...</span>
                <span v-else>Resend OTP</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

   <!-- Powered By Footer -->
  <div class="position-fixed bottom-0 start-50 translate-middle-x small text-white pb-3">
    © {{ currentYear }} Powered by <span class="fw-bold">{{ powered_by_name }}</span>
  </div>
